import {IApplicationState, TBoardId} from '../../../../types/types';

export const isAsideOpened = (state: IApplicationState, boardId: TBoardId): boolean => {
    return state.reports && state.reports[boardId] && state.reports[boardId].isAsidePanelShown;
};
